import { matchRoutes, Navigate, renderMatches, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toAppPath } from "../../lib/appNavigation";
import {
  fromObfuscatedUrl,
  getRouteTokenPrefix,
  tokenToPath,
} from "../../lib/routeTokens";
import { hasRole } from "../../lib/utility";
import { authSelector } from "../Auth/AuthSlice";
import { protectedAppRoutes } from "./protectedAppRoutes";

function resolveDecodedPath(decoded) {
  if (!decoded) return null;

  let { pathname, search = "" } = decoded;
  const prefix = getRouteTokenPrefix();

  if (pathname.startsWith(`${prefix}/`)) {
    const inner = fromObfuscatedUrl(pathname);
    if (!inner) return null;
    pathname = inner.pathname;
    search = inner.search || search;
  }

  return { pathname, search };
}

const ObfuscatedRouteOutlet = () => {
  const { routeToken } = useParams();
  const { user } = useSelector(authSelector);
  const decoded = resolveDecodedPath(tokenToPath(routeToken));
  const isAuthed = hasRole(user) && globalThis.isAuthenticated;
  const fallback = isAuthed ? toAppPath("/dashboard") : "/login";

  if (!decoded) {
    return <Navigate to={fallback} replace />;
  }

  const matches = matchRoutes(protectedAppRoutes, decoded);
  const element = renderMatches(matches);

  if (!element) {
    return <Navigate to={fallback} replace />;
  }

  return element;
};

export default ObfuscatedRouteOutlet;
